var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFF6F2",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h20v20H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 13.202a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm11.568 4.626-7.584-7.572A.8.8 0 0 0 17.6 10h-4.8a.8.8 0 0 0-.568.232l-2 1.993a.8.8 0 0 0-.232.568v4.803a.84.84 0 0 0 .232.568l7.592 7.604a.84.84 0 0 0 .568.232.8.8 0 0 0 .568-.232l6.808-6.812a.8.8 0 0 0 .232-.568.84.84 0 0 0-.232-.56zm-7.376 6.251L11.6 17.276v-4.154l1.52-1.521h4.144l6.8 6.795-5.672 5.683z",
    fill: "#2F665C",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSales);
export default __webpack_public_path__ + "static/media/ic-sales.08f2230d81c3ce1b677789217283cc07.svg";
export { ForwardRef as ReactComponent };